import axiosBase from 'axios';
import config from '../config/config';
import store from '../store/index';

const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const SERVER_ERRORS = {
	INCORRECT_LOGIN: 204,
	INCORRECT_USER_PASSWORD: 202,
	NO_SESSION: 207,
	USER_NOT_EXIST: 211,
	USER_SESSION_TIMEOUT: 209,
	LOGIN_REQUIRED: 401,
	FORBIDDEN: 403
};

const axios = axiosBase.create({
	baseURL: config.baseUrl,
	timeout: config.timeout
});

axios.interceptors.request.use(
	(config) => {
		// Do something before request is sent
		const paramsBefore = config.params || {};
		config.params = { ...paramsBefore, lang: store.getters.getSelectedLang };

		return config;
	},
	(error) => Promise.reject(error) // Do something with request error
);

axios.interceptors.response.use(
	// Identity handler
	(response) => response,
	// Error handler
	(error) => {
		const LOGIN_REQUIRED = error && error.response && error.response.status === SERVER_ERRORS.LOGIN_REQUIRED;
		const SESSION_NEEDED =
			error.response.data &&
			(error.response.data.internalCode === SERVER_ERRORS.USER_SESSION_TIMEOUT ||
				error.response.data.internalCode === SERVER_ERRORS.NO_SESSION);
		if (LOGIN_REQUIRED || SESSION_NEEDED) {
			store.dispatch('SESSION_EXPIRED');
		}

		return Promise.reject(error);
	}
);

axios.defaults.headers.common['Authorization'] = null;
axios.defaults.headers.timezone = timezone;

//  we don't need interceptor for this test to change token

export default axios;
